import { fetcher } from '@commenda/utils';
import { ChatRoomType } from '@prisma/client';

type BaseChatRoomProps = {
  chatRoomType: ChatRoomType;
};

// Create args for a filing's own thread, used while the filing has no service request:
type ComplianceItemCreateChatRoomProps = BaseChatRoomProps & {
  chatRoomType: 'COMPLIANCE_THREAD';
  complianceId: string;
  serviceRequestId?: string;
};

// Create args for marketplace service chat rooms:
type MarketplaceServiceCreateChatRoomProps = BaseChatRoomProps & {
  chatRoomType: 'MARKETPLACE_SERVICE_THREAD';
  marketplaceServiceId: string;
  companyId: number;
};

// Create args for bookkeeping service chat rooms:
type BookkeepingServiceCreateChatRoomProps = BaseChatRoomProps & {
  chatRoomType: 'BOOKKEEPING_THREAD';
  corporationId: number;
};

// Create args for service request chat rooms:
type ServiceRequestCreateChatRoomProps = BaseChatRoomProps & {
  chatRoomType: 'SERVICE_REQUEST_THREAD';
  serviceRequestId: string;
  complianceId?: string;
};

// Create args for general thread chat rooms:
type GeneralCreateChatRoomProps = BaseChatRoomProps & {
  chatRoomType: 'GENERAL_THREAD';
  companyId: number;
};

export type CreateChatRoomProps =
  | ComplianceItemCreateChatRoomProps
  | MarketplaceServiceCreateChatRoomProps
  | BookkeepingServiceCreateChatRoomProps
  | ServiceRequestCreateChatRoomProps
  | GeneralCreateChatRoomProps;

export async function createChatRoom({
  createChatRoomProps,
  token,
}: {
  createChatRoomProps: CreateChatRoomProps;
  token?: string;
}) {
  const res = await fetcher(
    `chatRoom`,
    {
      method: 'POST',
      body: createChatRoomProps,
    },
    token
  );

  return res;
}
